import { useCallback, useRef } from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import { useUiModalStore } from '../../store/uiModalStore';
import { showTerminalNotification } from '../../utils/terminalNotification';
import { formatDuration, shouldNotify } from './commandNotify';

/**
 * Card 5: the handler a pane's terminal calls when a command finishes
 * (`{ command, ms }`). It notifies when the command ran past the threshold
 * and the window is in the background or this pane is hidden. Reads the
 * latest pane name / visibility / preferences on every call.
 */
export function usePaneCommandNotify(t, { name, visible }) {
  const latest = useRef({});
  latest.current = { name, visible };

  return useCallback(
    ({ command, ms }) => {
      const p = usePreferencesStore.getState();
      const prefs = { on: p.terminalNotifyLongCommands !== false, seconds: p.terminalNotifySeconds, desktop: p.desktopNotifications };
      const appFocused = typeof document !== 'undefined' && document.hasFocus();
      // The terminal view stays mounted behind other pages: the pane is in
      // view only while its tab is the active one AND the Terminal page is shown.
      const paneVisible = latest.current.visible !== false && useUiModalStore.getState().activeTab === 'terminal.panel';
      if (!shouldNotify({ ms, appFocused, paneVisible }, prefs)) return false;
      showTerminalNotification({
        title: t('terminalExt.notifyTitle', 'Command finished · {{duration}}', { duration: formatDuration(ms) }),
        body: `${latest.current.name}: ${command}`,
      });
      return true;
    },
    [t]
  );
}
